import {CustomAutoCompleteMaps} from'./plugins/custom-auto-complete';
window.headerSchoolSearchLocationPlaces = null;
window.assistantSchoolSearchLocationPlaces = {};
$(function(){

    /*----------------- for header school search ---------------------*/
    let headerSchoolSearchId = document.getElementById('headerSchoolSearch');
    let headerSchoolSearchIdAutoComplete = new CustomAutoCompleteMaps(headerSchoolSearchId);
    let headerSchoolSearchLocationPlaces = '';
    let headerSchoolSearchLocation = '';
    let headerSchoolSearchLat = '';
    let headerSchoolSearchLng = '';
    if(!!headerSchoolSearchId){
        if (!!headerSchoolSearchIdAutoComplete) {
            CustomAutoCompleteMaps.addListener(headerSchoolSearchIdAutoComplete, 'place_changed', () => {
                headerSchoolSearchLocationPlaces = headerSchoolSearchIdAutoComplete.getPlace();
                headerSchoolSearchLocation = headerSchoolSearchLocationPlaces.formatted_address;
                headerSchoolSearchLat = headerSchoolSearchLocationPlaces.geometry.location.lat();
                headerSchoolSearchLng = headerSchoolSearchLocationPlaces.geometry.location.lng();
                window.headerSchoolSearchLocationPlaces = headerSchoolSearchLocationPlaces;
            });
        }
    }
    /*----------------- /for header school search ---------------------*/

    /*----------------- for assistant search ---------------------*/
    let assistantSchoolSearchId = document.getElementById('preferred-locality');
    let assistantSchoolSearchIdAutoComplete = new CustomAutoCompleteMaps(assistantSchoolSearchId);
    let assistantSchoolSearchLocation = '';
    let assistantSchoolSearchLat = '';
    let assistantSchoolSearchLng = '';
    if(!!assistantSchoolSearchId){
        if (!!assistantSchoolSearchIdAutoComplete) {
            CustomAutoCompleteMaps.addListener(assistantSchoolSearchIdAutoComplete, 'place_changed', () => {
                assistantSchoolSearchLocationPlaces = assistantSchoolSearchIdAutoComplete.getPlace();
                assistantSchoolSearchLocation = assistantSchoolSearchLocationPlaces.formatted_address;
                assistantSchoolSearchLat = assistantSchoolSearchLocationPlaces.geometry.location.lat();
                assistantSchoolSearchLng = assistantSchoolSearchLocationPlaces.geometry.location.lng();

                $('#preferred-latitude').val(assistantSchoolSearchLat);
                $('#preferred-longitude').val(assistantSchoolSearchLng);

                window.assistantSchoolSearchLocationPlaces = assistantSchoolSearchLocationPlaces;
            });
        }
    }
    /*----------------- /for assistant search ---------------------*/

});
